export default "__VITE_ASSET__CRWar1KW__"